'use client';
import { FC, useCallback } from 'react';
import {
  CatButton,
  CatGrid,
  CatGridItem,
  CatHeading
} from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { EquipmentResponse } from 'services/equipment/types';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import MyEquipmentCard from 'components/my-equipment/my-equipment-card';
import styles from '../../parts-layout/parts-layout.module.scss';

export interface MyEquipmentGridProps {
  equipment: EquipmentResponse;
  handleEditOpen: (equipment: Equipment) => void;
  partModificationFeatureFlag?: boolean;
}

const MyEquipmentGrid: FC<MyEquipmentGridProps> = ({
  equipment,
  handleEditOpen,
  partModificationFeatureFlag = false
}) => {
  const t = useTranslations();
  const { addEquipmentDrawer } = useMyEquipmentDrawer();
  const { myEquipmentList, selectedEquipmentIndex = -1 } = equipment || {};

  const handleOpen = useCallback(
    () => addEquipmentDrawer.openDrawer(),
    [addEquipmentDrawer]
  );

  return (
    <div className="w-100 d-flex flex-column row-gap-4">
      <CatHeading variant="title">{t('YOUR_EQUIPMENT')}</CatHeading>
      <CatButton variant="contrast" size="md" onClick={handleOpen}>
        {t('PDP_PARTSDIAGRAM_ADD_EQ_HEADING')}
      </CatButton>
      <CatGrid variant="5up" gap="sm">
        {(myEquipmentList ?? []).map((eq, i) => (
          <CatGridItem
            key={eq.uniqueIndex}
            className={styles['grid-item__mobile']}
          >
            <MyEquipmentCard
              equipment={eq}
              isSelected={i == selectedEquipmentIndex}
              handleEditOpen={handleEditOpen}
              partModificationFeatureFlag={partModificationFeatureFlag}
            />
          </CatGridItem>
        ))}
      </CatGrid>
    </div>
  );
};

export default MyEquipmentGrid;
